<template>
	<div>
		<div class="data-search">
			<el-row>
				<el-col :span="8">
					<el-input
					 placeholder="食材名称"
					 v-model="query.key"
					 clearable
					></el-input>
				</el-col>
				<el-col :span="2">
					<el-button
					 type="primary"
					 icon="el-icon-search"
					 @click="search"
					>搜索</el-button>
				</el-col>
				<el-col :span="4" style="margin-top: 5px;">
					 <el-switch
						v-model="query.edible"
						active-color="#13ce66"
						active-value="1"
						inactive-value="0">
					</el-switch>
					仅搜索常用食材
				</el-col>
				<el-col :span="4">
					<div class="grid-content"></div>
				</el-col>
				<el-col
				 :span="6"
				 style="text-align:right"
				>
				<span style="cursor:pointer" @click="changeDataMode(false)">
					<svg-icon
					 icon-class="datalist"
					 :style="listMode?{}:iconStyle"
					 style="width:2em;height:2em;"
					></svg-icon>
				</span>
				<span style="cursor:pointer" @click="changeDataMode(true)">
					<svg-icon
					icon-class="piclist"
					:style="picMode?{}:iconStyle"
					style="width:2em;height:2em;"
					></svg-icon>
				</span>
				<span style="cursor:pointer" @click="handleAdd">
					<svg-icon
					 style="color:#27B1A2;width:2em;height:2em;"
					 icon-class="add"
					></svg-icon>
				</span>
				</el-col>
			</el-row>
		</div>
		<div style="background:#F5F5F5;height:10px;width:100%"></div>
		<div
		 role="tablist"
		 aria-multiselectable="true"
		 class="el-collapse"
		 style="padding-right: 15px;"
		>
			<div class="el-collapse-item">
				<div
				 role="tabpanel"
				 class="el-collapse-item__wrap"
				>
					<el-collapse-transition>
						<div
						 class="el-collapse-item__content"
						 v-if="isShow"
						>
							<div class="search-condition" style="min-height: 30px;">
								<div style="float:left;width:38px">筛选：	</div>
								<div style="float:left;width:96%">	
									<el-tag
										v-for="(item,index) in tags"
										:key="index"
										closable
										type="danger"
										color="rgb(255, 122, 0)"
										effect="dark"
										@close="handleClose(item)">
										{{ item.name }}
									</el-tag>
								</div>
							</div>
							<div class="search-condition">
								<div style="float:left;width:38px">类别：</div>
								<div style="float:left;width:96%">
									<a class="el-link--default" @click="filterTags('cate')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
									<a class="el-link--default" @click="filterTags('cate',item)" v-for="(item, index) in ingredientCateList" :key="index">
										<span class="el-link--inner">{{item.cateName}}</span>
									</a>
								</div>
							</div>
							<div class="search-condition" style="padding-top:30px">季节：
								<a class="el-link--default" @click="filterTags('seasons')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('seasons',item)" v-for="(item, index) in seasons" :key="index">
									<span class="el-link--inner">{{item.name}}</span>
								</a>
							</div>
							<div class="search-condition">频次：
									<a class="el-link--default" @click="filterTags('frequency')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
									<a class="el-link--default" @click="filterTags('frequency',item)" v-for="(item, index) in frequency" :key="index">
										<span class="el-link--inner">{{item.name}}</span>
									</a>
							</div>
							<div class="search-condition">
								<div style="float:left;width:38px">地域：</div>
								<div style="float:left;width:96%">
									<a class="el-link--default" @click="filterTags('area')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
									<a class="el-link--default" @click="filterTags('area',item)" v-for="(item, index) in areaList" :key="index">
										<span class="el-link--inner">{{item.cityName}}</span>
									</a>
								</div>
							</div>
							<div class="search-condition"  style="padding-top:30px">人群：
								<a class="el-link--default" @click="filterTags('crowd')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('crowd',item)" v-for="(item, index) in crowd" :key="index">
									<span class="el-link--inner">{{item.name}}</span>
								</a>
								<span style="display:inline-block;margin-left:20px">清真：</span>
								<a class="el-link--default" @click="filterTags('halalFlag')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
								<a class="el-link--default" @click="filterTags('halalFlag',item)" v-for="(item, index) in halalFlag" :key="item.lable">
									<span class="el-link--inner">{{item.label}}</span>
								</a>
							</div>
							<div class="search-condition">
								<div style="float:left;width:38px">功效：</div>
								<div style="float:left;width:96%">
									<a class="el-link--default" @click="filterTags('efficacy')" style="font-size: 12px;"><span class="el-link--inner">不限</span></a>
									<a class="el-link--default" @click="filterTags('efficacy',item)" v-for="(item, index) in efficacy" :key="index">
										<span class="el-link--inner">{{item.name}}</span>
									</a>
								</div>
							</div>
							<div class="search-condition" style="padding-top:50px">营养素排行 </div>
							<div class="search-condition">
								<el-tag
										v-for="item in nutrient"
										:key="item.name"
										type=""
										style="cursor:pointer"
										:effect="item.type!=undefined?item.type:'plain'"
										@click="handleChooseNutrient(item)">
										{{ item.name }}
									</el-tag>
							</div>
						</div>
					</el-collapse-transition>
				</div>
				<div
				 role="tab"
				 aria-expanded="true"
				>
					<div
					 role="button"
					 tabindex="0"
					 class="el-collapse-item__header"
					 @click="isShow = !isShow"
					>{{isShow?'收起高级筛选':'展开高级筛选'}}<i
						 class="el-collapse-item__arrow"
						 :class="[isShow? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
						></i></div>
				</div>
			</div>
		</div>
		<div style="background:#F5F5F5;height:10px;width:100%"></div>
	</div>
</template>

<script>
import { fetchDictListByType,fetchIngredientCateList } from '@/api/dict'
import { fetchAreaList } from '@/api/city'
export default {
	name: "IngredientSearch",
	props: {
	},
  data() {
    return {
			isShow: false,
			listMode: false,
			picMode: true,
			mode: true,
			query: {
				key: null,
				halalFlag: null,
				edible: "1",
				areaIds: [],
				bigCateIds: [],
				crowdDictValues: [],
				efficacyDictValues: [],
				mealsGroupDictValues: [],
				nutrients: [],
				seasonDictValues: []
			},
			tags: [],
			iconStyle: {
				"color": "#dbdbdb"
			},
			ingredientCateList:[],// 类别
			seasons:[], //季节
			frequency:[], //频次
			areaList: [], //地域
			crowd: [], //人群
			efficacy: [], //功效
			halalFlag: [
				{value: '1', label: '清真'},
				{value: '0', label: '非清真'}
			],
			nutrient: [
				{name:"蛋白质",code:'protein'},
				{name:"脂肪",code:'fat'},
				{name:"碳水化合物",code:'carbohydrate'},
				{name:"热量",code:'energyKc'},
				{name:"钙",code:'autunite'},
				{name:"锌",code:'zicn'},
				{name:"铁",code:'iron'},
				{name:"维生素A",code:'va'},
				{name:"维生素B1",code:'vb1'},
				{name:"维生素B2",code:'vb2'},
				{name:"维生素C",code:'vc'}
			] //营养素
    };
	},
	created() {
		this.query = this.$store.getters.ingredientsParams;
		this.loadNutrient();
		this.loadBusDict('crowd');
		this.loadBusDict('season_number');
		this.loadBusDict('season');
		this.loadBusDict('efficacy');
		this.qeruyIngredientCateList();
		this.fetchAreaList();
		this.search();
	},
  methods: {
		loadNutrient() {
			const d = [{name:"不限",code:'',type:'dark'}];
			this.nutrient = this.nutrient.map(v=>{
				return {...v,type:'plain'}
			})
			this.nutrient = d.concat(this.nutrient);
			if(this.query.halalFlag) {
				this.halalFlag.forEach(item=>{
					this.query.halalFlag.forEach(te=>{
						if(item.value == te) {
							let tag = { id: item.value, name: item.label, type: 'halalFlag' };
							this.tags.push(tag);
						}
					})
				})
			}
			if(this.query.crowdDictValues.length > 0 || this.query.bigCateIds.length > 0 || this.query.efficacyDictValues.length > 0 
				 || this.query.halalFlag || this.query.mealsGroupDictValues.length > 0
				 || this.query.seasonDictValues.length > 0 || this.query.areaIds.length > 0) {
					 this.isShow = true;
			}
		},
		loadBusDict(code) {
			fetchDictListByType(code).then(response=>{
				if(code == 'crowd') {
					this.crowd = response.data;
					if(this.query.crowdDictValues) {
						this.crowd.forEach(item=>{
							this.query.crowdDictValues.forEach(te=>{
								if(item.value == te) {
									let tag = { id: item.value, name: item.name, type: 'crowd' };
									this.tags.push(tag);
								}
							})
						})
					}
				}
				if(code == 'season_number') {
					this.frequency = response.data;
					if(this.query.mealsGroupDictValues) {
						this.frequency.forEach(item=>{
							this.query.mealsGroupDictValues.forEach(te=>{
								if(item.value == te) {
									let tag = { id: item.value, name: item.name, type: 'frequency' };
									this.tags.push(tag);
								}
							})
						})
					}
				}
				if(code == 'season') {
					this.seasons = response.data;
					if(this.query.seasonDictValues) {
						this.seasons.forEach(item=>{
							this.query.seasonDictValues.forEach(te=>{
								if(item.value == te) {
									let tag = { id: item.value, name: item.name, type: 'seasons' };
									this.tags.push(tag);
								}
							})
						})
					}
				}
				if(code == 'efficacy') {
					this.efficacy = response.data;
					if(this.query.efficacyDictValues) {
						this.efficacy.forEach(item=>{
							this.query.efficacyDictValues.forEach(te=>{
								if(item.value == te) {
									let tag = { id: item.value, name: item.name, type: 'efficacy' };
									this.tags.push(tag);
								}
							})
						})
					}
				}
			})
		},
		qeruyIngredientCateList() {
			fetchIngredientCateList().then(response=>{
				this.ingredientCateList = response.data;
				if(this.query.bigCateIds) {
					this.ingredientCateList.forEach(item=>{
						this.query.bigCateIds.forEach(te=>{
							if(item.id == te) {
								let tag = { id: item.id, name: item.cateName, type: 'cate' };
								this.tags.push(tag);
							}
						})
					})
				}
			})
		},
		fetchAreaList() {
			fetchAreaList().then(response=>{
				this.areaList = response.data;
				if(this.query.areaIds) {
					this.areaList.forEach(item=>{
						this.query.areaIds.forEach(te=>{
							if(item.id == te) {
								let tag = { id: item.id, name: item.cityName, type: 'area' };
								this.tags.push(tag);
							}
						})
					})
				}
			})
		},
		filterTags(tagName,item) {
			if(tagName=='cate') {
				if(item) {
					if(this.query.bigCateIds.indexOf(item.id) > -1) {
					return;
				}
					let tag = { id:item.id ,name : item.cateName, type: tagName}
					this.tags.push(tag)
					this.query.bigCateIds.push(item.id);
				} else {					
					this.tags = this.tags.filter(ta => ta.type!=tagName);
					this.query.bigCateIds = [];
				}
				this.search();
			} else if(tagName=='area') {
				if(item) {
					if(this.query.areaIds.indexOf(item.id) > -1) {
					return;
				}
					let tag = { id:item.id ,name : item.cityName, type: tagName}
					this.tags.push(tag)
					this.query.areaIds.push(item.id);
				} else {					
					this.tags = this.tags.filter(ta => ta.type!=tagName);
					this.query.areaIds = [];
				}
				this.search();
			} else if(tagName == 'efficacy') {
				let values = this.filterDictTags(this.query.efficacyDictValues,tagName,item);
				if(values!=undefined) {
					this.query.efficacyDictId = values;
					this.search();
				}
			} else if(tagName == 'crowd') {
				let values = this.filterDictTags(this.query.crowdDictValues,tagName,item);
				if(values!=undefined) {
					this.query.crowdDictValues = values;
					this.search();
				}
			}  else if(tagName == 'frequency') {
				let values = this.filterDictTags(this.query.mealsGroupDictValues,tagName,item);
				if(values!=undefined) {
					this.query.mealsGroupDictValues = values;
					this.search();
				}
			}  else if(tagName == 'seasons') {
				let values = this.filterDictTags(this.query.seasonDictValues,tagName,item);
				if(values!=undefined) {
					this.query.seasonDictValues = values;
					this.search();
				}
			} else if(tagName == 'halalFlag') {
				if(item) {
					if(item.value && this.query.halalFlag == item.value){
						return;
					}
					let tag = { id:item.value ,name : item.label, type: tagName}
					this.tags = this.tags.filter(ta => ta.type!=tagName);
					this.tags.push(tag)
					this.query.halalFlag = item.value;
				} else {
					this.query.halalFlag = null;
				}
				this.search();
			} 
		},
		filterDictTags(query,tagName,item) {
			if(item) {
				if(query.indexOf(item.value) > -1) {
					return;
				}
				let tag = { id: item.value, name: item.name, type: tagName };
				this.tags.push(tag);
				query.push(item.value);
			} else {
				this.tags = this.tags.filter(ta => ta.type!=tagName);
				query = [];
			}
			return query;
		},
    handleClose(tag) {
			this.tags.splice(this.tags.indexOf(tag), 1);
			if(tag.type == 'cate') {
				this.query.bigCateIds.splice(this.query.bigCateIds.indexOf(tag.id), 1);
			}	else if(tag.type == 'area') {
				this.query.areaIds.splice(this.query.areaIds.indexOf(tag.id), 1);
			} else if(tag.type == 'efficacy') {
				this.query.efficacyDictValues.splice(this.query.efficacyDictValues.indexOf(tag.id), 1);
			} else if(tag.type == 'crowd') {
				this.query.crowdDictValues.splice(this.query.crowdDictValues.indexOf(tag.id), 1);
			} else if(tag.type == 'halalFlag') {
				this.query.halalFlag = null;
			} else if(tag.type == 'seasons') {
				this.query.seasonDictValues.splice(this.query.seasonDictValues.indexOf(tag.id), 1);
			} else if(tag.type == 'frequency') {
				this.query.mealsGroupDictValues.splice(this.query.mealsGroupDictValues.indexOf(tag.id), 1);
			}
			this.search();
		},
		handleChooseNutrient(item) {
			item.type='dark';
			this.nutrient.map(v=>{
				if(v.code !=item.code) {
					v.type = "plain"
				}
			})
			this.query.nutrients = item.code;
			this.search();
		},
    handleAdd() {
			this.$emit('handleAdd');
		},
		changeDataMode(val) {
			this.mode = val;
			this.listMode = !val;
			this.picMode = val;
			this.$emit('changeDataMode',val)
		},
		search() {
			this.$store.dispatch('setIngredientsParams',this.query);
			this.$emit('search',this.query,this.mode);
		}
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/ingredient/ingredient_search.vue